import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import { PAGE_TAG_MAPPING } from "./constants";

// each chat needs to set a tag for the page it was started from
// additionally there may be related ids (eg. studentId, schoolId)
export function getChatTags(href) {
  var tags = [];
  var tagItem = matchHrefToTag(href);
  if (tagItem) {
    tags.push("url:".concat(tagItem.tag));
    if (tagItem.getTagIds) {
      var idsToTags = href.match(tagItem.regex);
      var extraTags = idsToTags ? tagItem.getTagIds(idsToTags) : null;
      extraTags === null || extraTags === void 0 ? void 0 : extraTags.forEach(function (t) {
        return tags.push(t);
      });
    }
  } else {
    tags.push('url:unexpected');
  }
  return tags;
}
function matchHrefToTag(href) {
  var tagItem = PAGE_TAG_MAPPING.find(function (item) {
    return href.match(item.regex);
  });
  if (tagItem) {
    return tagItem;
  }
  return null;
}